import { AbstractContentState, useCmsContent } from '@cp-shared-10/frontend-integration';
import { ErrorPage } from 'common';
import { fetchUnauthorizedErrorPage } from './UnauthorizedErrorPageSlice';
import { UnauthorizedErrorPageContentSelector } from './UnauthorizedErrorPageContentSelector';

export function useUnauthorizedErrorPage(): AbstractContentState<ErrorPage> {
    return useCmsContent(fetchUnauthorizedErrorPage, UnauthorizedErrorPageContentSelector);
}
